import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DEFAULT_SEO, SITE_URL } from '../../seoConfig';

const SEOHead = ({ 
  title, 
  description, 
  canonical,
  noindex = false,
  ogImage,
  ogType = "website"
}) => {
  const pageTitle = title || DEFAULT_SEO.title;
  const pageDescription = description || DEFAULT_SEO.description;
  const pageCanonical = canonical || SITE_URL;
  const pageImage = ogImage || DEFAULT_SEO.image;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={pageDescription} />
      
      {/* Canonical */}
      <link rel="canonical" href={pageCanonical} />
      
      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={pageCanonical} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={DEFAULT_SEO.siteName} />
      <meta property="og:locale" content={DEFAULT_SEO.locale} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={pageCanonical} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
      
      {/* Additional SEO */}
      <meta name="geo.region" content="DE-BW" />
      <meta name="geo.placename" content="Stuttgart" />
      <meta name="author" content="HK Altbausanierung" />
    </Helmet>
  );
};

export default SEOHead;
